import * as actions from './actions'
import * as mutations from './mutations'

export default{
  namespaced: true,
  state () {
    return {
      street: '',
      postalCode: '',
      town: '',
      city: '',
      country: 'ES'
    }
  },
  actions,
  mutations
}
